function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .az {\n                fill: #fff;\n                opacity: 0;\n            }\n\n            .by {\n                fill: #ea0029;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-166 -595)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "az",
  width: 27.3,
  height: 27.3,
  transform: "translate(166 595)"
}), /*#__PURE__*/React.createElement("path", {
  className: "by",
  d: "M19.451,19.615a1.942,1.942,0,0,0,1.935-1.945l.01-9.725A1.945,1.945,0,0,0,19.451,6H3.89A1.938,1.938,0,0,0,1.945,7.945V17.67A1.945,1.945,0,0,0,3.89,19.615H0v1.945H23.341V19.615Zm-6.808-3.433v-2.13c-2.7,0-4.483.827-5.835,2.645.545-2.6,2.052-5.184,5.835-5.709V8.918l3.89,3.628Z",
  transform: "translate(168 595)"
}));

function SvgSharingScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.3,
    height: 27.3,
    viewBox: "0 0 27.3 27.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharingScreen);
export default __webpack_public_path__ + "static/media/sharing_screen.92c79fdf.svg";
export { ForwardRef as ReactComponent };